var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('item-list');
import { breakpoints, theme } from '@shapeable/theme';
export var ItemListDefaultProps = {
  spaceUnits: 4,
  items: []
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0;\n    list-style: none;\n    padding: 0;\n  "], ["\n    margin: 0;\n    list-style: none;\n    padding: 0;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var spaceUnits = _a.spaceUnits;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin: 0 0 ", " 0;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    "], ["\n      margin: 0 0 ", " 0;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    "])), theme.UNIT(spaceUnits));
  })
});
// -------- Components -------->
var My = {
  Container: styled.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled.li.attrs(cls.attr('item'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
export var ItemList = function (props) {
  var className = props.className,
    items = props.items,
    spaceUnits = props.spaceUnits;
  if (!items.length) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, items.map(function (item, i) {
    return React.createElement(My.Item, {
      key: i,
      spaceUnits: spaceUnits
    }, item);
  }));
};
ItemList.defaultProps = ItemListDefaultProps;
ItemList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;